import _every from "lodash/every";
import parse from "date-fns/parse";
import isValid from "date-fns/isValid";
import compareAsc from "date-fns/compareAsc";
import closestIndexTo from "date-fns/closestIndexTo";
import add from "date-fns/add";
import ro from "date-fns/locale/ro";

const StoreSpecialSchedule = ({ schedule }) => {
  // TODO: We should use setDefaultOptions to set global defaults for date-fns
  const currentDate = new Date();
  const scheduleDateFormat = "d MMMM";
  const scheduleDateParseOptions = { locale: ro };

  const parsedSchedule = Object.entries(schedule).map(([date, openHours]) => {
    let dateObject;
    let isValidDate = false;

    try {
      // The schedule date doesn't contain the year
      // Use the current year to set year context
      const currentYearScheduleDate = parse(
        date,
        scheduleDateFormat,
        currentDate,
        scheduleDateParseOptions
      );

      isValidDate = isValid(currentYearScheduleDate);

      if (isValidDate) {
        // Guess the schedule date year
        const nextYearScheduleDate = add(currentYearScheduleDate, {
          years: 1,
        });

        dateObject =
          closestIndexTo(currentDate, [
            currentYearScheduleDate,
            nextYearScheduleDate,
          ]) === 0
            ? currentYearScheduleDate
            : nextYearScheduleDate;
      }
    } catch (error) {
      console.log(`Special schedule date ${date} is invalid: ${error}`);
    }

    return { date, openHours, dateObject, isValidDate };
  });

  const isValidSchedule = _every(
    parsedSchedule,
    (schedule) => schedule.isValidDate
  );

  const sortedSchedule =
    isValidSchedule &&
    parsedSchedule.sort((scheduleA, scheduleB) =>
      compareAsc(scheduleA.dateObject, scheduleB.dateObject)
    );

  if (!isValidSchedule) return null;

  return sortedSchedule.map(({ date, openHours }, index) => (
    <div className="flex" key={index}>
      <span className="mr-1">{date}:</span> {openHours}
    </div>
  ));
};

export default StoreSpecialSchedule;
